/**
 * Get the display name for a platform
 * Backend now sends correct display names, so this is mainly for backward compatibility
 */
export const getPlatformDisplayName = (platformName: string): string => {
  if (!platformName) return platformName;
  
  // Backend now sends "X" as display_name, but keep this for backward compatibility
  const normalized = platformName.toLowerCase().trim();
  if (normalized === 'twitter') {
    return 'X';
  }
  
  return platformName;
};

/**
 * Normalize platform name for internal use (keeps "twitter" as is for API compatibility)
 */
export const normalizePlatformName = (platformName: string): string => {
  if (!platformName) return platformName;
  return platformName.toLowerCase().trim();
};

